export default function Router($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider
        .when("/app/analytics", "/app/analytics/");

    $stateProvider
        .state({
            name: "analytics",
            url: "/app/analytics/",
            template: "<analytics></analytics>"
        })
        .state({
            name: "analyticsDetail",
            url: "/app/analytics/:id",
            template: "<analytics-detail></analytics-detail>"
        });
}


// WEBPACK FOOTER //
// ./sources/components/analytics/analytics-router.js